import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const PolicyAcknowledgementTaskDefinition: TaskDefinition<'HandbookPagesPage'> = {
  taskableTypename: 'HandbookPagesPage',
  getUrl: ({ info, navigation }) => {
    if (!info.id || !info.folderType) return null

    return navigation.pages.folder.page.fullPath({
      folderSlug: info.folderType,
      pageId: info.id,
    })
  },
  getTitle: ({ info }) => {
    return info.title ?? ''
  },
}
